import React, { useEffect } from "react";

// Style
import "./GameEnd.scss";
import { EmptyStar, StarFilled } from "./../../assets/images/home/icons";

import Party from "./../../assets/images/home/game-end.svg";
import { GC } from "../../services/config/gameCenteService";
import { storage } from "../../services/config/storage";

const GameEnd = (props) => {
  const goToNextGame = () => {
    GC.sendGameEndMessage()
    storage.destroy.all();
  };
  return (
    <div
      className="component-game-end"
    // onClick={() => (window.location = "/skullberry/home")}
    >
      <div className="complete-modal">
        <div className="levels">
          <img className="stars" src={Party} alt={"star"} />{" "}
          {/* <div className="stars">
            <div style={{ transform: "rotate(-30deg)", marginTop: "53px" }}>
              <StarFilled width="60px" height="60px" />
            </div>
            <div>
              <StarFilled />
            </div>
            <div
              style={{
                transform: "rotate(23deg)",
                marginTop: "43px",
                marginLeft: "3px",
              }}
            >
              <StarFilled width="60px" height="60px" />
            </div>
          </div> */}
        </div>
        <div className="heading">You did great !</div>
        <div className="details-box">
          <div className="info-box">
            <div className="time">Time Taken</div>
            <div className="accuracy">
              {" "}
              {Math.floor((420 - localStorage.getItem("time")) / 60) < 10
                ? `0${Math.floor((420 - localStorage.getItem("time")) / 60)}`
                : Math.floor((420 - localStorage.getItem("time")) / 60)}
              :
              {(420 - localStorage.getItem("time")) % 60 < 10
                ? `0${(420 - localStorage.getItem("time")) % 60}`
                : (420 - localStorage.getItem("time")) % 60}
            </div>
          </div>
          <div className="info-box">
            <div className="time">Levels Cleared</div>
            <div className="accuracy">{localStorage.getItem("levelsDone")}</div>
          </div>
        </div>
        {/* <div className="closure">You did better than 95% players</div> */}
        <div className="button-div">
          <div className="top-btn" onClick={() => goToNextGame()}>Contine</div>
          <div className="bottom-btn" onClick={() => goToNextGame()}>Continue</div>
        </div>
      </div>
    </div>
  );
};

export default GameEnd;
